export const environment = {
  production: true,
  appInsights: {
    instrumentationKey: '60f6e35d-f705-4592-a213-5e62e8100b5f',
    // instrumentationKey: 'INSTRUMENTATION_KEY_REPLACE',
  }
};
